import React, { PureComponent as Component } from "react";
import KickImage from 'Reuseables/KickImage';
import { Row, Col, Container } from "reactstrap";
import propTypes from "prop-types";

export default class Footer extends Component {
  render() {
    // console.log('PROPS FOOTER ', this.props);
    return (
      <Col className="size-footer" xs={12}>
        <Container className="other-info-container">
          <Row>
            <Col xs={12} md={4}>
              <p>
                {this.props.box_condition === undefined
                  ? "-"
                  : this.props.box_condition === "SEMPURNA"
                  ? "ORIGINAL BOX"
                  : this.props.box_condition === "CACAT"
                  ? "DAMAGED BOX"
                  : "Missing Box"}
              </p>
            </Col>
            <Col xs={12} md={3}>
              <p className="text-center">{this.props.SKU}</p>
            </Col>
            <Col xs={12} md={5}>
              <p className="text-right">{this.props.colour}</p>
            </Col>
          </Row>
        </Container>
      </Col>
    );
  }
}

Footer.propTypes = {
  box_condition: propTypes.string,
  SKU: propTypes.string,
  colour: propTypes.string
};
